import React from "react";
import { Avatar, styled, Typography, useTheme } from "@mui/material";
import { UploadCardProps } from "../../Cards/UploadCard/upload-card";
import { Img } from "react-image";
import { userService } from "../../../Core/Api/services";

export interface AvatarProfilePictureProps {
  userId?: number | undefined;
  userFirstName?: string | undefined | null;
  userLastName?: string | undefined | null;
  userInitials?: string | undefined;
  onClick?: any;
  open?: boolean;
  size?: number;
}

const AvatarProfilePicture: React.FC<AvatarProfilePictureProps> = (props) => {
  const {
    userId = undefined,
    userFirstName = undefined,
    userLastName = undefined,
    userInitials = undefined,
    onClick,
    open,
    size = 36,
  } = props;
  const theme = useTheme();
  const _renderAvatar = (
    <Avatar
      aria-label="more"
      aria-controls={open ? "long-menu" : undefined}
      aria-expanded={open ? "true" : undefined}
      aria-haspopup="true"
      onClick={onClick}
      sx={{
        width: size,
        height: size,
        color: "text.primary",
        bgcolor: "backgroundAlpha.main",
        cursor: onClick ? "pointer" : "default",
        border: `1px solid ${theme.palette.primary.alphaHover}`,
        "&:hover": onClick
          ? {
              bgcolor: theme.palette.primary.alphaHover,
              border: `1px solid ${theme.palette.primary.main}`,
            }
          : {},
      }}
    >
      <Typography color="text.primary" fontWeight={600}>
        {!userInitials
          ? `${userFirstName?.charAt(0)?.toUpperCase()}${userLastName?.charAt(0)?.toUpperCase()}`
          : userInitials}
      </Typography>
    </Avatar>
  );

  return (
    <>
      {userId ? (
        <Img
          aria-label="more"
          aria-controls={open ? "long-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
          style={{
            cursor: onClick ? "pointer" : "default",
          }}
          width={size}
          height={size}
          onClick={onClick}
          src={[userService.GetUserAvatarProfileUrl(userId)]}
          loader={_renderAvatar} // Used while loading
          unloader={_renderAvatar} // Used when image not loaded like 404
          container={(children) => {
            // <img> will be rendered as child of
            return <ProfilePicture coverRounded={true}>{children}</ProfilePicture>;
          }}
        />
      ) : (
        _renderAvatar
      )}
    </>
  );
};

export default AvatarProfilePicture;

const ProfilePicture = styled("figure", {
  shouldForwardProp: (prop) => prop !== "coverRounded" && prop !== "coverPlaceholderIcon",
})<{
  coverRounded?: UploadCardProps["coverRounded"];
  coverPlaceholderIcon?: UploadCardProps["coverPlaceholderIcon"];
}>(({ theme, coverRounded, coverPlaceholderIcon }) => ({
  width: 32,
  height: 32,
  borderRadius: coverRounded ? 40 : 6,
  overflow: "hidden",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundImage: coverPlaceholderIcon
    ? "none"
    : "radial-gradient(102.68% 102.68% at 102.68% 0%, rgba(51, 104, 244, 0.8) 0%, rgba(51, 104, 244, 0.3) 53.4%, rgba(51, 104, 244, 0.3) 100%)",
  backgroundColor: coverPlaceholderIcon ? theme.palette.backgroundAlpha.main : "transparent",
  img: {
    ...theme.helpers(theme).fullImage,
  },
  ".MuiSvgIcon-root": {
    fontSize: 40,
    color: theme.palette.text.tier,
  },
}));
